import * as React from 'react';
import {view, css} from '@sail/ui';

export const ExamplePanel = ({
  children,
}: {
  children: React.ReactNode,
}): JSX.Element => {
  return (
    <view.div
      uses={[
        css({
          background: 'container',
          paddingX: 'medium',
          paddingY: 'large',
          font: 'caption',
          color: 'secondary',
          marginTop: 'small',
          borderRadius: 'medium',
          border: css.value('1px dashed'),
          borderColor: 'neutral',
        }),
      ]}
    >
      {children}
    </view.div>
  );
};
